import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { initGlobalTheme } from './composables/useTheme.js'

// uni.scss 已通过 vite.config.js 自动导入到所有 SCSS 文件中

// 模拟uni-app环境
window.uni = {
  showToast: (options) => {
    console.log('Toast:', options.title)
    // 已禁用弹出提示
  },
  
  showLoading: (options) => {
    console.log('Loading:', options.title || '加载中...')
  },
  
  hideLoading: () => {
    console.log('Hide loading')
  },
  
  navigateTo: (options) => {
    if (options.url) {
      // 简单的路由导航
      window.location.hash = options.url
    }
  },
  
  redirectTo: (options) => {
    if (options.url) {
      window.location.hash = options.url
      window.location.reload()
    }
  },
  
  navigateBack: () => {
    window.history.back()
  },
  
  getStorageSync: (key) => {
    try {
      return localStorage.getItem(key) || ''
    } catch (e) {
      return ''
    }
  },
  
  setStorageSync: (key, value) => {
    try {
      localStorage.setItem(key, value)
    } catch (e) {
      console.warn('Storage failed:', e)
    }
  },
  
  removeStorageSync: (key) => {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      console.warn('Remove storage failed:', e)
    }
  },
  
  chooseImage: (options) => {
    // 模拟图片选择
    return new Promise((resolve) => {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.multiple = options.count > 1
      
      input.onchange = (e) => {
        const files = Array.from(e.target.files)
        resolve({
          tempFiles: files.map(file => ({
            path: URL.createObjectURL(file),
            size: file.size,
            name: file.name,
            type: file.type
          }))
        })
      }
      
      input.click()
    })
  },
  
  uploadFile: (options) => {
    // 模拟文件上传
    return {
      onProgressUpdate: (callback) => {
        // 模拟上传进度
        let progress = 0
        const timer = setInterval(() => {
          progress += 10
          callback({ progress })
          if (progress >= 100) {
            clearInterval(timer)
            options.success && options.success({
              data: JSON.stringify({
                url: 'https://picsum.photos/800/600?random=' + Date.now()
              })
            })
          }
        }, 100)
      }
    }
  },
  
  showModal: (options) => {
    console.log('Modal:', options.title, options.content)
    // 已禁用确认对话框，默认返回确认
    return Promise.resolve({ confirm: true })
  },
  
  getSystemInfoSync: () => ({
    platform: 'h5',
    system: navigator.userAgent,
    theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  })
}

// 创建Vue应用
const app = createApp(App)

// 安装插件
app.use(createPinia())

// 初始化全局主题
initGlobalTheme()

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err, info)
}

// 挂载应用
app.mount('#app')

// 初始化用户状态（在应用挂载后）
import { useUserStoreHook } from './store/modules/user.js'
const userStore = useUserStoreHook()
userStore.initUserState().then(() => {
  console.log('用户状态初始化完成，当前登录状态:', userStore.isLoggedIn)
})